import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { ref, onMounted, onBeforeUnmount } from 'vue'
import loadingCanvas from '@/components/LoadingCanvas.vue'
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()
onMounted(() => {
  init();
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', forceLandscapeScreenHandle)
})
const init = () => {
  forceLandscapeScreenHandle();
  // 这里监控
  onWindowSizeChanged();
}

const forceLandscapeScreenHandle = () => {
  const body = document.getElementsByTagName('body')[0];
  const html = document.getElementsByTagName('html')[0];
  const width = html.clientWidth;
  const height = html.clientHeight;
  const max = width > height ? width : height;
  store.commit('upNowClient', max)
  const min = width > height ? height : width;
  body.style.width = max + "px";
  body.style.height = min + "px";

}

const onWindowSizeChanged = () => {
  window.addEventListener("resize", forceLandscapeScreenHandle)
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).state.isLoading)
      ? (_openBlock(), _createBlock(loadingCanvas, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})